import React, {forwardRef, useImperativeHandle, ReactNode } from 'react';


export interface DialogRef {
    show: () => void,
    close: () => void
}
export type DialogProps = {
    id: string;
    children: ReactNode;
    onClose?: () => void;
    onClear?: () => void;
}
const Dialog = forwardRef((props:DialogProps, ref: React.Ref<DialogRef> | undefined) => {

    const { id, children, onClose = () => {}, onClear = () => {} } = props;

    const control = React.useRef<HTMLDialogElement>(null);

    const handleMouseClick = (event: MouseEvent) => {
        // ダイアログクローズ時はイベントを抑制（handleCloseの２重実行抑制）
        if (!control.current?.open) return;
        // マウスクリックのみを処理する
        if ((event as PointerEvent).pointerType !== 'mouse') return;

        const rect = control.current?.getBoundingClientRect();
        if (!rect) return;

        const isInDialog = (
          rect.top <= event.clientY &&
          event.clientY <= rect.top + rect.height &&
          rect.left <= event.clientX &&
          event.clientX <= rect.left + rect.width
        );
        if (!isInDialog) handleClose();
    }
    const handleKeydown = (event: KeyboardEvent) => {
        if (event.key === 'Escape') {
            handleClose();
        }

    };
    const handleOpen = () => {
        control.current?.showModal();

        // スクロール禁止（※モーダルを2重で開く場合には未対応）
        document.body.style.overflow = 'hidden';

        // イベント登録
        document.addEventListener('click', handleMouseClick);
        document.addEventListener('keydown', handleKeydown);
    }
    const handleClose = () => {
        control.current?.close();

        // スクロール許可（※モーダルを2重で開く場合には未対応）
        document.body.style.overflow = '';

        // イベント除去
        document.removeEventListener('click', handleMouseClick);
        document.removeEventListener('keydown', handleKeydown);

        // クローズイベント実行
        onClose();
    }
    const handleClear = () => {
        // クリアイベント実行
        onClear();
    }

    useImperativeHandle(ref, () => ({
        show: () => {
            handleOpen();
        },
        close: () => {
            handleClose();
        }
    }));

    return (
        <dialog id={id} className="c-modal" ref={control}>
        <div className="c-modal-card">
            <div className="c-modal-close">
                <button type="button" className="c-button c-button--sm c-button--secondary" onClick={handleClose}>
                    <span className="c-button__txt">保存して閉じる</span>
                </button>
                <div className="button-right">
                    <button type="button" className="c-button c-button--sm c-button--secondary" onClick={handleClear}>
                        <span className="c-button__txt">クリア</span>
                    </button>
                </div>
            </div>
            <div className="c-modal-body">
            <div className="c-modal-inner">
                {children}
            </div>
            </div>
        </div>
        </dialog>
    )
});
export default Dialog;